module.exports = __webpack_public_path__ + "img/Group 49.e10a3f69.svg";